export default __webpack_public_path__ + "static/media/nft-2.522efaa7.png";